import React from 'react';
import { Checkbox } from 'components';
import Hightlighter from 'react-highlight-words';
import { ArrowDown, ArrowRightForSelectedGroup } from 'assets/icons';
import * as S from '../../ChooseBrandsModels.styled';

const BrandItem = ({ isOpened, onOpenClick, brandData, toggleCheck, search }) => {
  return (
    <S.Row>
      <S.ArrowIconWrapper isOpen={isOpened} onClick={onOpenClick}>
        {isOpened ? <ArrowDown /> : <ArrowRightForSelectedGroup />}
      </S.ArrowIconWrapper>
      <Checkbox
        isChecked={brandData.isSelected}
        id={brandData.brand}
        name={brandData.brand}
        onChange={() => {
          toggleCheck(brandData.brand);
        }}
        isOpenGroup
      />
      <S.GroupName>
        <Hightlighter
          textToHighlight={brandData.brand}
          searchWords={[search]}
          highlightTag='strong'
        />
      </S.GroupName>
      <S.Brand>Brand</S.Brand>
    </S.Row>
  );
};

export default BrandItem;
